import React, { useState } from "react";
import { makeStyles, lighten } from "@material-ui/core/styles";
import { Paper, Box } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { baseUrl } from "@jumbo/constants/baseUrl";

const useStyles = makeStyles((theme) => ({
  container: {
    width: 100,
    height: 100,
  },
  paper: {
    position: "relative",
    width: "100%",
    height: "100%",
    backgroundColor: lighten(theme.palette.background.paper, 0.1),
    marginBlock: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  imageContainer: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  closeButtonContainer: {
    position: "absolute",
    top: "0",
    right: "0",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  closeButton: {
    opacity: 0,
    transform: "scale(0.8)",
    transition: "opacity 0.3s ease, transform 0.3s ease",
  },
  icon: {
    width: 30,
    height: 30,
    background: "#fff",
    borderRadius: "50%",
    opacity: 0,
    transform: "scale(0.8)",
    transition: "opacity 0.3s ease, transform 0.3s ease",
  },
}));

export default function ImagePreview({ src, handleRevome, styles }) {
  const [hover, setHover] = useState(false);
  const handleMouseEnter = () => setHover(true);
  const handleMouseLeave = () => setHover(false);
  const classes = useStyles();

  return (
    <Box style={{ ...styles }} className={classes.container}>
      <Paper
        elevation={4}
        className={classes.paper}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <img
          crossOrigin="anonymous"
          className={classes.imageContainer}
          src={`${baseUrl}file/get/${src}`}
          alt="cover"
        />
        <Box className={classes.closeButtonContainer}>
          <CloseIcon
            className={classes.icon}
            style={{
              opacity: hover ? 1 : 0,
              transform: hover ? "scale(1)" : "scale(0.8)",
            }}
            onClick={handleRevome}
          />
        </Box>
      </Paper>
    </Box>
  );
}
